import useAuthorized from "hooks/useAuthorized";

/**
 * Renders `children` only while the current user holds `permissions`.
 *
 * `partialMatch` mirrors `useAuthorized`: any single granted permission is
 * enough, instead of requiring all of them. `fallback` renders in place of
 * `children` while access is denied.
 */
const Authorized = ({
  permissions = [],
  partialMatch = false,
  fallback = null,
  children,
}) => {
  const isAuthorized = useAuthorized(permissions, { partialMatch });

  return isAuthorized ? children : fallback;
};

export default Authorized;
